import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["date", "reminder"]
  static values = { reminderDaysBefore: { type: Number, default: 5 } }

  suggestReminder() {
    if (!this.hasReminderTarget) return
    if (this.reminderTarget.value) return

    const eventDate = new Date(this.dateTarget.value)
    if (isNaN(eventDate.getTime())) return

    const reminderDate = new Date(eventDate)
    reminderDate.setDate(reminderDate.getDate() - this.reminderDaysBeforeValue)

    if (reminderDate <= new Date()) return

    this.reminderTarget.value = this.formatDateTimeLocal(reminderDate)
  }

  setReminder(event) {
    if (!this.hasReminderTarget || !this.hasDateTarget) return

    const eventDate = new Date(this.dateTarget.value)
    if (isNaN(eventDate.getTime())) {
      // Use toast notification instead of disruptive alert dialog
      if (typeof window.showToast === "function") {
        window.showToast("Please set the event date first", "warning")
      }
      return
    }

    const daysBefore = parseInt(event.currentTarget.dataset.days, 10)
    const reminderDate = new Date(eventDate)
    reminderDate.setDate(reminderDate.getDate() - daysBefore)

    if (reminderDate <= new Date()) {
      // Use toast notification instead of disruptive alert dialog
      if (typeof window.showToast === "function") {
        window.showToast("That reminder time has already passed", "warning")
      }
      return
    }

    this.reminderTarget.value = this.formatDateTimeLocal(reminderDate)
  }

  formatDateTimeLocal(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }
}
